import styled from "src/settings/theme/styled";
import theme from "src/settings/theme";

export const Title = styled.span`
  position: relative;
  font-size: 4rem;
  display: inline;
  line-height: 1.2;
  margin: 0;
  letter-spacing: -1px;
  will-change: transform, opacity;
  overflow: hidden;
  color: ${({ theme }) => theme.colors.white};

  ${theme.breakpoints.mobile} {
    font-size: 3rem;
  }
`;

export const TitleLink = styled.a`
  position: relative;
  font-size: 4rem;
  display: inline;
  line-height: 1.2;
  margin: 0;
  letter-spacing: -1px;
  will-change: transform, opacity;
  overflow: hidden;
  text-decoration: none;
  color: ${({ theme }) => theme.colors.gray};
  transition: ${({ theme }) => theme.animations.defaultTransition};
  &:hover {
    color: ${({ theme }) => theme.colors.white};
  }
  ${theme.breakpoints.mobile} {
    font-size: 3rem;
  }
`;

export const Logo = styled.img`
  width: 40px;
  ${theme.breakpoints.mobile} {
    width: 30px;
  }
`;
